import { Component, Input } from '@angular/core';

@Component({
    selector: 'zwi-sermon-category-row',
    templateUrl: './sermon-category-row.component.html',
    styleUrls: ['./sermon-category-row.component.scss'],
    standalone: false
})
export class SermonCategoryRowComponent {
  constructor() {}
}
